/* Auxilary Functions for Questionnaire.js */

import * as Constants from '../Utilities/Constants';
import * as api from '../Scripts/Api';
import {LanguageText} from "../Utilities/LanguageText";

import {
    getTextFiveToSevenDays,
    getTextNoFormalEducation,
    getTextThreeToFourDays,
    getTextUnsure,
    getTextYes
} from "../Utilities/LanguageText";

// Returns the number of days in a month
export function getDaysForMonth (month) {
    const short_months = [4, 6, 9, 11]

    if(month === 2) {
      return 29
    } else if (short_months.includes(month)) {
      return 30
    }

    return 31
  }

// Changes Date object into MM/DD/YYYY format
export function format_birthdate (new_text) {

    let number_string = String(new_text).substring(0,10).split('').filter(char => !isNaN(char)).join('')
    const month_section = number_string.substring(0,2)
    let month_text = Number(month_section) <= 12 ? month_section : month_section[0]
    const date_section = number_string.substring(month_text.length, month_text.length + 2)
    let date_text = Number(date_section) < getDaysForMonth(month_text) ? date_section : date_section[0]


    let year_text = number_string.substring(date_text.length + month_text.length, date_text.length + month_text.length + 4)

    if(month_text.length === 0){
        return ''
    } else if(month_text.length === 1) {
        month_text = '0' + month_text
    }
    if(date_text.length === 0){
        date_text = "DD"
    }else if(date_text.length === 1) {
        date_text = '0' + date_text
    }
    if(year_text.length === 0){
        year_text = "YYYY"
    } else while (year_text.length !== 4) {
        year_text = '0' + year_text
    }

    return  month_text + "/" + date_text + "/" + year_text


}





// Returns age from a birthdate
export function convertBirthdayToAge (birthday) {
  let birth = new Date(birthday)
  return Math.floor((new Date() - new Date(birth).getTime()) / 3.15576e+10) // 1 year in ms
}



//Takes in the inches and feet and returns total inches
export function calculate_height (feet, inches) {
    let inches_from_feet = Number(feet) * 12
    let inches_from_inches = Number(inches)
    return inches_from_feet + inches_from_inches
}

// calculates the user's BMI from their height (in) and weight (lb)
export function calculateBMI (height_answer, weight_answer) {

    let height = height_answer * Constants.INCHES_TO_METERS
    let weight = weight_answer * Constants.POUNDS_TO_KG

    let bmi = weight / (height * height)
    return bmi
}

//gets the lower weight limit of bmi
export function getLowerBMI (height) {
    return getWeightAtBMI(height, 10)
}

//gets the upper weight limit of bmi
export function getUpperBMI (height) {
    return getWeightAtBMI(height, 120)
}

//Passes in a bmi and uses the user's height
//to calculate what their weight would be
//returns the answer in pounds
export function getWeightAtBMI (height, bmi) {
    const meters = (height * Constants.INCHES_TO_METERS)
    const kilograms = bmi * meters * meters
    return Constants.KG_TO_POUNDS * kilograms
}

// calculates the risk assessment score to determine if they need to take the test
export function riskScoreIndicatesScreening(question_answers) {
    let assessmentId = sessionStorage.getItem("assessmentId");
    let score = getRiskScore(question_answers)
    api.record_prompt_response(Constants.PT_QUESTION_NAMES.RISK, score)
    api.upload_assessment_data(assessmentId, 'dsi', score);
    return score >= 22;
}

// Calculates a users risk score given their questionnaire answers
function getRiskScore(question_answers){
    console.log("calculating risk score...")
    const langText = new LanguageText(sessionStorage.getItem("prefLang"));

    console.log('getRiskScore, answers: ' + question_answers)
    let Q_NAMES = Constants.PT_QUESTION_NAMES;
    let score = 0

    const height = question_answers[Q_NAMES.HEIGHT];
    const weight = question_answers[Q_NAMES.WEIGHT];
    let yearsAbove65 = question_answers[Q_NAMES.BIRTHDAY] - 65
    score += yearsAbove65 > 0 ? yearsAbove65 : 0 // for ages > 65
    score += question_answers[Q_NAMES.HIGH_SCHOOL] === langText.No ? 9 : 0 // finishing high school
    score += calculateBMI(height, weight) < 18.5 ? 8 : 0 // for low BMI
    score += question_answers[Q_NAMES.DIABETES] === langText.Yes ? 3 : 0 // for diabetes
    score += question_answers[Q_NAMES.STROKE] === langText.Yes ? 6 : 0 // stroke
    score += question_answers[Q_NAMES.HELP] === langText.Yes ? 10 : 0 // help with money/meds
    score += question_answers[Q_NAMES.ANTIDEPRESSANTS] === langText.Yes ||
      question_answers[Q_NAMES.ANTIDEPRESSANTS] === langText.Unsure ||
      question_answers[Q_NAMES.EFFORT] === langText.ThreeToFourDays  ||
      question_answers[Q_NAMES.EFFORT] === langText.FiveToSevenDays ? 6 : 0 // antidepressant use

    sessionStorage.setItem("RISK SCORE", score)
    console.log("finished calculating risk score")
    console.log("RISK SCORE", score)
    return score

}

// // Used to test that risk calculations are behaving as expected
// export function testRiskScore() {
//
//   //The fields are       age, hs,  height, weight, diab, stroke, help, anti-d, effort
//   let set1 = createAnswers(65, 'YES', '72', '120', 'No', 'No', 'No', 'No', Constants.ONE_TWO)
//   let set2 = createAnswers(70, 'YES', '72', '150', 'No', 'No', 'No', 'No', Constants.ONE_TWO)
//   let set3 = createAnswers(79, 'No', '72', '150', 'Yes', 'No', 'No', 'No', Constants.ONE_TWO)
//   let set4 = createAnswers(50, 'Yes', '72', '150', 'Yes', 'Yes', 'No', 'No', Constants.ONE_TWO)
//   let set5 = createAnswers(50, 'Yes', '72', '150', 'No', 'No', 'Yes', 'No', Constants.ONE_TWO)
//   let set6 = createAnswers(50, 'Yes', '72', '150', 'No', 'No', 'No', 'Yes', Constants.ONE_TWO)
//   let set7 = createAnswers(50, 'Yes', '72', '150', 'No', 'No', 'No', 'Yes', Constants.THREE_FOUR)
//   let set8 = createAnswers(50, 'Yes', '72', '150', 'No', 'No', 'No', 'No', Constants.THREE_FOUR)
//
//
//   console.log('set1', getRiskScore(set1) === 8)
//   console.log('set2', getRiskScore(set2) === 5)
//   console.log('set3', getRiskScore(set3) === 14 + 9 + 3)
//   console.log('set4', getRiskScore(set4) === 3 + 6)
//   console.log('set5', getRiskScore(set5) === 10)
//   console.log('set6', getRiskScore(set6) === 6)
//   console.log('set7', getRiskScore(set7) === 6)
//   console.log('set8', getRiskScore(set8) === 6)
//
//
// }
//


// Creates mock data to aid in testing the risk score functionality
function createAnswers(age, hs, height, weight, diabetes, stroke, help, antidepressants, effort){
  let Q_NAMES = Constants.PT_QUESTION_NAMES;

  return {
    [Q_NAMES.WEIGHT] : weight,
    [Q_NAMES.HEIGHT] : height,
    [Q_NAMES.BIRTHDAY] : age,
    [Q_NAMES.HIGH_SCHOOL] : hs,
    [Q_NAMES.DIABETES] : diabetes,
    [Q_NAMES.STROKE] : stroke,
    [Q_NAMES.HELP] : help,
    [Q_NAMES.ANTIDEPRESSANTS]: antidepressants,
    [Q_NAMES.EFFORT]: effort
  }

}
